// export default function downloadBlob(data, fileName, format) {
//     const MIME_TYPES = {
//         xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//         xls: 'application/vnd.ms-excel',
//         pdf: 'application/pdf',
//         csv: 'text/csv;charset=utf-8;'
//     };
    
//     const blobType = MIME_TYPES[format] || 'application/octet-stream';
//     const blob = new Blob([data], { type: blobType });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');

//     link.href = url;
//     link.setAttribute('download', fileName);

//     document.body.appendChild(link);

//     link.click();
//     link.remove();
// }

export default function downloadBlob(data, fileName, format) {
    const MIME_TYPES = {
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      xls: 'application/vnd.ms-excel',
      pdf: 'application/pdf',
      csv: 'text/csv;charset=utf-8;',
    };

    const filetypesThatRequiresBOM = ['xls', 'csv'];
  
    const blobType = MIME_TYPES[format] || 'application/octet-stream';

    // Add UTF-8 BOM
    const BOM = '\uFEFF';
    const blobData = filetypesThatRequiresBOM.includes(format)
      ? [BOM + data]
      : [data];

    const blob = new Blob(blobData, { type: blobType });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
  
    link.href = url;
    link.setAttribute('download', fileName);
  
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  